export default "__VITE_ASSET__148fa461__"